module.exports = __webpack_public_path__ + "static/img/foot.4417d49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CloudQuickPrinting/foot.png
// module id = cD1D
// module chunks = 10